import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

export function AvatarGroup(avatarGroupProps: ComponentProps<'div'>) {
  const { className, ...props } = avatarGroupProps;
  return <div data-slot={'avatar-group'} className={cn('flex h-fit w-fit shrink-0 items-center', className)} {...props} />;
}

export function AvatarGroupContent(avatarGroupContentProps: ComponentProps<'div'>) {
  const { className, ...props } = avatarGroupContentProps;
  return <div data-slot={'avatar-group-content'} className={cn('inline-flex -space-x-1', className)} {...props} />;
}
export function AvatarGroupButtonMore(avatarGroupButtonMoreProps: ComponentProps<'button'>) {
  const { className, ...props } = avatarGroupButtonMoreProps;
  return (
    <button
      className={cn(
        'bg-accent m-0 min-w-7 text-muted-foreground outline-focus-ring [&_svg]:pointer-events-none&_svg]:size-4 z-10 flex aspect-square shrink-0 cursor-pointer items-center justify-center rounded-md p-0.5 opacity-100 outline-0 transition-colors duration-150 focus-visible:outline-3 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-75 [&_svg]:shrink-0',
        className
      )}
      {...props}
    />
  );
}
